export default __webpack_public_path__ + "static/media/aboutArtistImage.1892fcef.png";